import { DialogActions, Grid } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';
import { FormEvent, ReactNode } from 'react';
import { RestError } from '@azure/core-http';
import { parseErrorMessage } from '../../../core/api/api.context';
import { Modal } from '../../../ui/components/pure/modal/modal.component';
import { TextButton } from '../../../ui/components/pure/text-button/text-button.component';
import { dialogActionsStyle, rowGroupStyle } from './courier-form.styles';

/**
 * The chrome around a courier form: title, save/cancel, and the API error. Create and edit differ
 * only in their title, their fields and which mutation they call, so everything else lives here.
 */
export function CourierFormModal({
  title,
  loading,
  saving,
  error,
  submitLabel = 'Save',
  onCancel,
  onSubmit,
  children
}: {
  title: string;
  loading?: boolean;
  saving?: boolean;
  /** What the submit button reads as. */
  submitLabel?: string;
  error?: RestError | Error;
  onCancel(): void;
  onSubmit(event: FormEvent): void;
  children: ReactNode;
}) {
  return (
    <Modal title={title} open={true} loading={loading || saving} maxWidth="sm" divider>
      <form noValidate autoComplete="off" onSubmit={onSubmit}>
        <Grid container sx={{ flexDirection: 'column' }} style={{ width: '100%', margin: 0 }}>
          {children}

          {error && (
            <Grid container spacing={2} style={rowGroupStyle}>
              <Grid size={12}>
                <Alert variant="outlined" severity="error">
                  <AlertTitle>Something went wrong</AlertTitle>
                  {parseErrorMessage(error.message)}
                </Alert>
              </Grid>
            </Grid>
          )}
        </Grid>
        <DialogActions style={dialogActionsStyle}>
          <TextButton color="secondary" variant="outlined" onClick={onCancel}>
            Cancel
          </TextButton>
          <TextButton color="primary" variant="contained" type="submit">
            {submitLabel}
          </TextButton>
        </DialogActions>
      </form>
    </Modal>
  );
}
